export default {
  messages: {
    nl: {
      pageTitle: 'Uw cookies zijn geblokkeerd',
      noCookiesMessage: 'Het PGB Portaal gebruikt cookies voor het inloggen. U kunt niet inloggen als u cookies blokkeert of het gebruik van cookies niet toestaat in uw browser.' +
        ' Schakel cookies daarom niet helemaal uit, want dan kunt u niet inloggen.',
      readMore: 'Lees meer over het gebruik van cookies.',
      employeesLink: 'Bent u werkzaam voor een verstrekker of de SVB?',
      budgethouderLink: 'Inloggen PGB Portaal',
    },
  },
}
